// Across the top of every screen on a staging shop floor, signed in or not,
// so nobody mistakes a labs record for the real one or the reverse. Never
// dismissable: the whole point is that it is there the moment someone looks
// up. The installed app carries the same message in its name and icon
// (server/src/http/staging.ts), and the server decides which this is — the
// client only repeats what /api/session/info said.
//
// Amber on purpose, and the same amber as the icon and podOS's own staging
// banner: one colour that means "test" across the labs apps. It is a fixed
// value rather than a palette token because it must read the same in light
// and dark and under every accent somebody has picked.
//
// In the flow rather than floating over the page: a strip that covers the
// time or the station name would be cropped away in people's heads within a
// day. Every full-height screen subtracts its height instead (--sf-banner,
// set on the root by App).

import { useT } from '@/i18n/useT';
import { useStore } from '@/store';

/** The strip's height, which the full-height screens subtract from the viewport. */
export const STAGING_BANNER_HEIGHT = 28;

export function StagingBanner() {
  const t = useT();
  const deployment = useStore((s) => s.deployment);
  if (deployment?.odooEnvironment !== 'staging') return null;

  const sentence = t.stagingBannerT.replace('{host}', deployment.odooHost);
  return (
    <div
      role="status"
      aria-label={`${t.stagingT}: ${sentence}`}
      title={sentence}
      style={{
        flex: 'none',
        height: STAGING_BANNER_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '0 12px',
        background: '#b45309',
        color: '#fff',
        font: '600 11.5px Manrope,sans-serif',
      }}
    >
      <span
        style={{
          flex: 'none',
          font: "700 10px 'Space Grotesk',sans-serif",
          letterSpacing: '.08em',
          textTransform: 'uppercase',
        }}
      >
        {t.stagingT}
      </span>
      <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', opacity: 0.92 }}>
        {deployment.odooHost} · {t.notProductionT}
      </span>
      {/* The other shop floor: a plain link, since it is another origin with
          its own sign-in. */}
      {deployment.peerOrigin && (
        <a href={deployment.peerOrigin} style={{ flex: 'none', color: 'inherit', textDecoration: 'underline' }}>
          {t.productionAppT}
        </a>
      )}
    </div>
  );
}
